<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-4 col-md-4 col-lg-4 col-sm-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total Cost ({{ cloudability_spend.length}} months)</p>
              <h4 class="card-title">${{ parseInt(total_spend /1000) }}k</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Updated daily / page refreshed at {{last_update}}
            </div>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-4 col-lg-4 col-sm-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content" >
              <p class="card-category" v-b-tooltip.hover >Simple Average:<br>(last 3 months)</p>
              <h4 class="card-title" >{{str_AVG.slice(0,str_AVG.length-3)}}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Updated daily / page refreshed at {{last_update}}
            </div>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-4 col-lg-4 col-sm-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content" >
              <p class="card-category" v-b-tooltip.hover >Weighted Average:<br>(last 3 months)</p>
              <h4 class="card-title" >{{str_AVG.slice(0,str_WAVG.length-3)}}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Updated daily / page refreshed at {{last_update}}
            </div>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-4 col-lg-4 col-sm-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content" >
              <p class="card-category" v-b-tooltip.hover :title="'using projected average of last 3 months'">Projected 24m (AVG)</p>
              <h4 class="card-title" > <span v-bind:style= "[projected24m<580000 ? {'color':'red'} : {'color':'green'}]">{{parseInt(AVG*24/1000)}}k</span></h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Updated daily / page refreshed at {{last_update}}
            </div>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-4 col-lg-4 col-sm-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content" >
              <p class="card-category" v-b-tooltip.hover :title="'using projected weighted average of last 3 months'">Projected 24m (WAVG)</p>
              <h4 class="card-title" > <span v-bind:style= "[projected24m<580000 ? {'color':'red'} : {'color':'green'}]">{{parseInt(WAVG*24/1000)}}k</span></h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Updated daily / page refreshed at {{last_update}}
            </div>
          </stats-card>
        </div>
        <div class="col-xl-4 col-md-4 col-lg-4 col-sm-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Commitment (24 months)</p>
              <h4 class="card-title">580k</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Updated daily / page refreshed at {{last_update}}
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row" style="position: relative">
        <div class="col rotated-labels">
          <chart-card :key='cloudability_costs_data' :chart-data="cloudability_costs_data.data"
                      :chart-options="cloudability_costs_data.options"
                      :responsive-options="cloudability_costs_data.responsiveOptions"
                      chart-type="Line"
                      >
            <template slot="header">
              <h4 class="card-title" >Cloudability Costs Breakdown</h4>
              <p class="card-category">Values in $</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle" :style='{color: colors[0]}'></i> weighted average of last 3 months
                <i class="fa fa-circle" :style='{color: colors[1]}'></i> Cloudability virtual monthly cost
                <!-- <i class="fa fa-circle" :style='{color: colors[2]}'></i> 2020 -->

              </div>

              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated monthly / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
        <div class="col-md-12 rotated-labels" >
          <chart-card :key='aws_budget_data' :chart-data="aws_budget_data.data"
                      :chart-options="aws_budget_data.options"
                      :responsive-options="aws_budget_data.responsiveOptions"
                      chart-type="Line" 
                      >
            <template slot="header">
              <h4 class="card-title">AWS Monthly Cost</h4>
              <p class="card-category">Values in Thousands</p>
            </template>
          </chart-card>
        </div>

      </div>
    </div>
  </div>  
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'

  import { colors, formatMoney, formatSimple, formatSimple2d, chart_base } from 'src/globalVariables'
  import { setInterval } from 'timers';


  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    async created() {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData()
      var vm = this
      setInterval(function(){
        vm.loadData()
      },vm.refresh_minutes*60*1000)

    },
    methods: {
      on_click: function(period){
        this.referenceDate= period.substring(0,4)+'-'+period.substring(4,6)+'-01'
        this.loadData()

      },
      loadData: function(){
        var today = new Date();
        this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
        console.log('refreshing...',)
        axios
          .get("/cloudability/monthly-spend?filters=transaction_type%21%3Dtax&dimensions=year_month&end_date=yesterday&limit=50&metrics=unblended_cost&order=asc&sort_by=year_month&start_date=2019-04-01")
          .then(response => (this.cloudability_spend = response.data.results))
        axios
          .get('aws/budget-run?st_date=201904&access_token=' + this.accessToken)
          .then(response => (this.aws_budget = response.data))

        return true
      },
      refresh_aws:function(){
        var labels = []
        var series = []
        if (this.aws_budget){
          this.aws_budget.forEach(function(v, i){
            labels.push(v['year_month'])
            series.push((v['total_cost']/1000).toFixed(2))
            
          })
        }
        // console.log(labels)
        // console.log(series)
        this.aws_budget_data = {
          'data': {
            'labels': labels,
            'series': [series],
          },
          'options': Object.assign({}, chart_base.options),
          'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
        }
        //override of chart_base
        this.aws_budget_data.options.seriesBarWidth=40
        this.aws_budget_data.options.seriesBarDistance = 5
        this.aws_budget_data.options.tooltip.transformTooltipTextFnc = function(value) {
                return formatSimple2d.format(value)+'K'}
        this.aws_budget_data.options.chartPadding= {
            'bottom': 50,
          },
        this.aws_budget_data.responsiveOptions = [
            ['screen and (max-width: 518px)', {
              'seriesBarDistance': 3,
              'seriesBarWidth': 2,
              'axisX': {
                    labelInterpolationFnc(value) {
                        return value.substring(value.length - 2)+'/'+value.substring(2, 4)
                    }
                }
            }],
              ['screen and (min-width: 520px)', {
                'seriesBarDistance': 5,
                'axisX': {
                    labelInterpolationFnc(value) {
                        return value.substring(value.length - 2)+'/'+value.substring(2, 4)
                    }
                }
            }],
        ]

      },

      refresh_cloudability: function() {
        var labels = []
        var series1 = []
        var spend = 0
        var total = 0
        var avg_series = []
        var wavg_series = []
        var avg = -1
        var sum = 0
        var last3 = []
        if (this.cloudability_spend){
          total = 0
          this.cloudability_spend.forEach(function(v, i){
            spend = v['unblended_cost'].replace(/,/g,'').replace('$','') * 0.91 /100
            labels.push(v['year_month'])
            series1.push({ "value": spend})
            total += spend
          })
          this.total_spend = total

          // using a AVG of 3 last months to predict the 24 months costs
          this.cloudability_spend.forEach(function(v,i){
            spend = v['unblended_cost'].replace(/,/g,'').replace('$','') * 0.91 /100
            
            // calculating last3 steps
            if (i==0){
              last3.push(spend)  
              last3.push(spend)  
              last3.push(spend)  
              avg_series.push(spend)
              wavg_series.push(spend)
              
            } else{
              last3.splice(0,1)
              last3.push(spend)
            }
            avg = (last3[0] + last3[1] + last3[2]) / 3
            avg_series.push(avg)
            avg = (last3[0]*3 + last3[1]*2 + last3[2]) / 6
            wavg_series.push(avg)
          })
          avg_series.splice(avg_series.length-1,1)
          wavg_series.splice(wavg_series.length-1,1)
          this.projected24m = wavg_series[wavg_series.length-1] * 24
          this.str_AVG = formatMoney.format(avg_series[avg_series.length-1])
          this.str_WAVG = formatMoney.format(wavg_series[wavg_series.length-1])
          this.AVG = avg_series[avg_series.length-1]
          this.WAVG = wavg_series[wavg_series.length-1]
          
          this.cloudability_costs_data = {
            'data': {
              'labels': labels,
              'series': [wavg_series,series1]
            },
            'options': Object.assign({}, chart_base.options),
            'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
          }

          //override of chart_base
          this.cloudability_costs_data.options.seriesBarWidth=150
          this.cloudability_costs_data.options.chartPadding= {
            'bottom': 50,
          },

          this.cloudability_costs_data.responsiveOptions = [
            ['screen and (max-width: 518px)', {
              'seriesBarDistance': 5,
              'axisX': {
                    labelInterpolationFnc(value) {
                        return value.substring(value.length - 2)+'/'+value.substring(2, 4)
                    }
                }
            }],
              ['screen and (min-width: 520px)', {
                'seriesBarDistance': 5,
                'axisX': {
                    labelInterpolationFnc(value) {
                        return value.substring(value.length - 2)+'/'+value.substring(2, 4)
                    }
                }
            }],
          ]

        }
      }
    },
    watch: {
      cloudability_spend:function(){
        this.refresh_cloudability()
      },
      aws_budget:function(){
        this.refresh_aws()
      },

    },
    computed: {
      
    },
    data () {
      return {
        accessToken: '',
        refresh_minutes: 30,
        projected24m:0,
        AVG:0,
        WAVG:0,
        str_AVG:'',
        str_WAVG:'',
        total_spend: 0,
        last_update: '',
        colors: colors,
        cloudability_spend:{},
        cloudability_costs_data:{},
        chartsDone:false,
        aws_budget:[],
        aws_budget_data:{},
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        referenceDate: '2018-01-01'
      }
    }
  }
</script>
<style scoped >
.projected-chart {
    opacity:0.7;

}
</style>
